export default "__VITE_ASSET__3c596c19__"